<template>
  <div class="context-menu-parent">
    <div class="context-menu" @mouseover.prevent.stop="mouseover($event)" @mouseleave.prevent.stop="mouseleave($event)" v-if="!isOuter">
      <slot></slot>
    </div>
    <div class="context-menu" @contextmenu.prevent.stop="contextmenu($event)"  v-else>
      <slot></slot>
    </div>
      <div @contextmenu.prevent.stop v-if="show" class="context-menu-box" ref="context-menu-box" @click="close" :style="{left:left + 'px',top:top + 'px','visibility':isVisible ? 'visible' : 'hidden'}">
        <slot name="item"></slot>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isOuter:false
  },
  data() {
    return {
      show: false,
      left: 0,
      top: 0,
      isVisible:false
    }
  },
  mounted() {
    window.addEventListener('click', e => {
      this.clearBox(e)
    })
    window.addEventListener('mousedown', e => {
      if (e.button !== '0') {
        this.clearBox(e)
      }
    })
  },
  methods: {
    clearBox(e) {
      let box = this.$refs['context-menu-box']
      let fl = (e.path || e.composedPath()).find(res => res === box)
      if (!fl) {
        this.show = false
      }
    },
    mouseover() {
      this.$emit('itemCheck',true)
    },
    mouseleave() {
      this.$emit('itemCheck',false)
    },
    contextmenu(e) {
      console.log(window.innerWidth,e.pageX + 192)
      this.isVisible = false
      this.show = true
      let winWidth = window.innerWidth
      let winHeight = window.innerHeight
      if (this.disabled) {
        return
      }
      this.left = e.pageX + 20
      this.top = e.pageY + 20
      this.$nextTick(() => {
        let width = this.$refs['context-menu-box'].offsetWidth
        let height = this.$refs['context-menu-box'].offsetHeight
        if(this.left + width > winWidth){
          this.left = this.left - width
        }
        if(e.pageY + height > winHeight){
          this.top = this.top - height
        }
        this.isVisible = true
      })
    },
    close() {
      this.show = false
    }
  }
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.context-menu-parent {
  position: relative;
  .context-menu {
    width: 100%;
    height: 100%;
  }
  .context-menu-box {
    width: 172px;
    // min-height: 40px;
    background-color: #fff;
    box-shadow: 0px 4px 8px 0px rgba(214, 217, 221, 1);
    position: fixed;
    // transition: all 0.3s;
    border-radius: 4px;
    z-index: 99;
  }
}
</style>
